var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":("/api2/resource/ConvertUrlToQrCodeImage?url=" + _vm.url),"height":_vm.size,"width":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }